import colors from '_containers/Theme/corporate/colors';

export default {
  background: `transparent`,
  action: colors.all.brandPrimary1,
  playButtonBackground: `rgba(255, 255, 255, 0.7)`
};
